import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

const PricingCard = ({ title, price, highlighted, features, period = '/mês', positionType = 'normal' }) => {
  const navigate = useNavigate();

  return (
    <Card
      className={`h-100 position-relative pricing-card ${highlighted ? 'pricing-card-highlight' : 'pricing-card-normal'}`}
      style={{
        backgroundColor: highlighted ? '#1a1d24' : '#ffffff',
        border: highlighted ? '2px solid #00f3ff' : '1px solid rgba(0,0,0,0.05)',
        borderRadius: '12px',
        boxShadow: highlighted ? '0 10px 30px rgba(0, 243, 255, 0.12)' : '0 5px 20px rgba(0,0,0,0.04)',
        transition: 'all 0.3s ease'
      }}
    >
      {highlighted && (
        <div style={{
          position: 'absolute',
          top: '-16px',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#00f3ff',
          color: '#151822',
          padding: '4px 12px',
          borderRadius: '20px',
          fontWeight: 'bold',
          fontSize: '0.75rem',
          letterSpacing: '1px',
          boxShadow: '0 0 10px rgba(0,243,255,0.5)',
          whiteSpace: 'nowrap',
          zIndex: 2
        }}>
          MAIS VANTAJOSO
        </div>
      )}
      <CardBody className="p-3 py-4 d-flex flex-column">
        <h3 className="text-uppercase mb-2" style={{
          color: highlighted ? '#00f3ff' : '#2a3042',
          fontWeight: 'bold',
          letterSpacing: '1px',
          fontSize: '1.25rem'
        }}>
          {title}
        </h3>

        <div className="mb-3">
          <span style={{ fontSize: '0.9rem', color: highlighted ? '#a6b0cf' : '#74788d', verticalAlign: 'top' }}>R$</span>
          <span style={{ fontSize: '2.2rem', fontWeight: 'bold', color: highlighted ? '#ffffff' : '#2a3042', lineHeight: '1' }}>{price}</span>
          <span style={{ fontSize: '0.9rem', color: highlighted ? '#a6b0cf' : '#74788d', marginLeft: '2px' }}>{period}</span>
        </div>

        <ul className="list-unstyled mb-4 flex-grow-1">
          {features.map((feature, idx) => (
            <li key={idx} className="mb-2 d-flex align-items-center" style={{ color: feature.active ? (highlighted ? '#e9ecef' : '#495057') : '#adb5bd' }}>
              <i className={`mdi ${feature.active ? 'mdi-check-circle' : 'mdi-close-circle'} me-2`}
                style={{
                  color: feature.active ? (highlighted ? '#00f3ff' : '#2ecc71') : (highlighted ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'),
                  fontSize: '1.05rem',
                  display: 'flex',
                  alignItems: 'center'
                }}>
              </i>
              <span style={{ textDecoration: feature.active ? 'none' : 'line-through', fontSize: '0.85rem' }}>
                {feature.text}
              </span>
            </li>
          ))}
        </ul>

        <button
          onClick={(e) => {
            e.preventDefault();
            navigate('/checkout', { state: { plan: { title, price, period } } });
          }}
          className="btn w-100 py-2 text-uppercase fw-bold text-center text-decoration-none d-block"
          style={{
            backgroundColor: highlighted ? '#00f3ff' : 'transparent',
            color: highlighted ? '#151822' : '#2a3042',
            border: highlighted ? 'none' : '2px solid #e9ecef',
            borderRadius: '12px',
            transition: 'all 0.3s ease',
            letterSpacing: '1px',
            boxShadow: highlighted ? '0 0 15px rgba(0,243,255,0.3)' : 'none'
          }}
          onMouseEnter={(e) => {
            if (!highlighted) {
              e.currentTarget.style.backgroundColor = '#f4f5f8';
              e.currentTarget.style.borderColor = '#ced4da';
            } else {
              e.currentTarget.style.boxShadow = '0 0 25px rgba(0,243,255,0.6)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }
          }}
          onMouseLeave={(e) => {
            if (!highlighted) {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.borderColor = '#e9ecef';
            } else {
              e.currentTarget.style.boxShadow = '0 0 15px rgba(0,243,255,0.3)';
              e.currentTarget.style.transform = 'translateY(0)';
            }
          }}
        >
          Começar Agora
        </button>
      </CardBody>
    </Card>
  );
};

const PricingSection = () => {
  return (
    <div style={{ backgroundColor: '#f4f5f8', padding: '80px 0', position: 'relative', overflow: 'hidden' }}>
      <Container fluid className="px-4 px-xl-5">
        <div className="text-center position-relative mb-5 pb-4 d-flex flex-column align-items-center">
          {/* Sombra Esboçada (Texto de Fundo) */}
          <div className="position-absolute text-uppercase d-flex align-items-center justify-content-center" style={{
            fontSize: 'clamp(5rem, 11vw, 12rem)',
            fontWeight: '900',
            color: 'transparent',
            WebkitTextStroke: '2px rgba(0, 0, 0, 0.05)',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 0,
            pointerEvents: 'none',
            userSelect: 'none',
            letterSpacing: '15px',
            whiteSpace: 'nowrap',
            width: '100%'
          }}>
            PLANOS
          </div>

          <h2 className="text-uppercase position-relative mb-0" style={{ fontSize: 'clamp(3rem, 6vw, 5rem)', fontWeight: 'bold', color: '#2a3042', zIndex: 1, letterSpacing: '2px' }}>
            Nossos <span style={{ color: '#00f3ff', textShadow: '0 0 15px rgba(0,243,255,0.3)' }}>Planos</span>
          </h2>

          {/* Subtítulo com Faixa Vertical Neon */}
          <div className="d-flex position-relative mt-4 mx-auto" style={{ zIndex: 1, maxWidth: '750px' }}>
            <div
              style={{
                width: '4px',
                backgroundColor: '#00f3ff',
                boxShadow: '0 0 8px #00f3ff, 0 0 15px rgba(0, 243, 255, 0.4)',
                borderRadius: '2px',
                marginRight: '18px',
                flexShrink: 0
              }}
            ></div>
            <p className="mb-0 text-start" style={{ color: '#495057', fontSize: 'clamp(1.1rem, 1.4vw, 1.4rem)', fontWeight: '400', lineHeight: '1.6' }}>
              Escolha o pacote ideal para decolar a gestão do seu negócio esportivo, desde o básico até o mais avançado nível de inteligência artificial.
            </p>
          </div>
        </div>

        <Row className="align-items-center justify-content-center pt-4 g-4 position-relative" style={{ zIndex: 2 }}>

          {/* Slot 1: Plano Free 30 Dias (Outer Left) */}
          <Col xl lg={4} md={6} className="order-2 order-xl-1">
            <PricingCard
              title="Teste Grátis"
              price="0"
              period="/30 dias"
              highlighted={false}
              positionType="outer"
              features={[
                { text: 'Acesso liberado a tudo', active: true },
                { text: 'Gestão de Alunos e Turmas', active: true },
                { text: 'Controle Financeiro e DRE', active: true },
                { text: 'Avaliações Técnicas', active: true },
                { text: 'Plan. Automático de Objetivos', active: true },
                { text: 'Gameficação', active: true },
                { text: 'Automação de Msg CRM', active: true },
                { text: 'I.A. Neo Core (Plan)', active: true },
                { text: 'Suporte VIP', active: true },
              ]}
            />
          </Col>

          {/* Slot 2: Plano Personal (Adjacent Left) */}
          <Col xl lg={4} md={6} className="order-3 order-xl-2">
            <PricingCard
              title="Personal"
              price="99"
              highlighted={false}
              positionType="adjacent"
              features={[
                { text: 'Limite de até 20 Alunos', active: true },
                { text: 'Gestão de Alunos e Turmas', active: true },
                { text: 'Controle Financeiro', active: true },
                { text: 'Controle de Presença', active: true },
                { text: 'Suporte', active: true },
                { text: 'Avaliação do Aluno', active: true },
                { text: 'Automação de Msg CRM', active: false },
                { text: 'I.A. Neo Core', active: false },
                { text: 'Plan. Automático de Treinos', active: false },
              ]}
            />
          </Col>

          {/* Slot 3: Plano Completo (MAIS VANTAJOSO - Center) */}
          <Col xl lg={4} md={6} className="order-1 order-xl-3 mb-4 mb-xl-0">
            <PricingCard
              title="Completo"
              price="490"
              highlighted={true}
              positionType="center"
              features={[
                { text: 'Gestão de Alunos e Turmas', active: true },
                { text: 'Controle Financeiro e DRE', active: true },
                { text: 'Avaliações Técnicas', active: true },
                { text: 'Suporte VIP', active: true },
                { text: 'Plan. Automático de Objetivos', active: true },
                { text: 'Gameficação', active: true },
                { text: 'Automação de Msg CRM', active: true },
                { text: 'I.A. Neo Core (Plan)', active: true },
                { text: 'Criação de Testes Custom', active: true },
              ]}
            />
          </Col>

          {/* Slot 4: Plano Básico (Adjacent Right) */}
          <Col xl lg={4} md={6} className="order-4 order-xl-4">
            <PricingCard
              title="Básico"
              price="299"
              highlighted={false}
              positionType="adjacent"
              features={[
                { text: 'Gestão de Alunos e Turmas', active: true },
                { text: 'Controle Financeiro Completo', active: true },
                { text: 'Avaliações Técnicas', active: true },
                { text: 'Testes Personalizados', active: true },
                { text: 'Gameficação', active: true },
                { text: 'Suporte Premium', active: true },
                { text: 'Automação de Msg CRM', active: false },
                { text: 'I.A. Neo Core', active: false },
                { text: 'Plan. Automático de Treinos', active: false },
              ]}
            />
          </Col>

          {/* Slot 5: Plano Inicial (Outer Right) */}
          <Col xl lg={4} md={6} className="order-5 order-xl-5">
            <PricingCard
              title="Inicial"
              price="199"
              highlighted={false}
              positionType="outer"
              features={[
                { text: 'Gestão de Alunos e Turmas', active: true },
                { text: 'Controle Financeiro', active: true },
                { text: 'Controle de Presença', active: true },
                { text: 'Suporte', active: true },
                { text: 'Avaliação do Aluno', active: true },
                { text: 'Automação de Msg CRM', active: false },
                { text: 'I.A. Neo Core', active: false },
                { text: 'Plan. Automático de Treinos', active: false },
              ]}
            />
          </Col>

        </Row>
      </Container>
      <style>
        {`
          .pricing-card:hover {
            transform: translateY(-5px);
            z-index: 10;
          }
        `}
      </style>
    </div>
  );
};

export default PricingSection;
